<template>
  <a-row class="content-fix">
    <!-- <pre style="overflow: hidden; width: 400px">{{ $data }}</pre> -->
    <spinner v-show="loading" />

    <span v-show="!loading && !croping">
      <a-row class="content-title" type="flex" style="padding-top: 10px">
        <a-col :span="6" />
        <a-col :span="12">
          <h2>
            {{
              form && form.id
                ? "Изменение пользователя"
                : "Добавление пользователя"
            }}
          </h2>
        </a-col>
      </a-row>

      <a-row class="sm-mb">
        <a-col :span="6" />
        <a-col :span="12">
          <a-avatar
            shape="square"
            icon="user"
            :size="128"
            :src="avatarSrc"
            style="width: 241px; height: 143px"
          />

          <input
            ref="refAvatarInput"
            type="file"
            accept="image/jpeg, image/png"
            hidden
            @change="handleImage"
          />
          <span class="ml-1">
            <a-button @click="$refs.refAvatarInput.click()"
              >Выбрать фото</a-button
            >
          </span>
        </a-col>
      </a-row>

      <a-row class="input-form__group">
        <a-col
          :span="6"
          style="text-align: right; padding-right: 8px; padding-top: 5px"
        >
          Имя:
        </a-col>
        <a-col :span="12">
          <a-input v-model="form.first_name" placeholder="Введите Имя" />
        </a-col>
      </a-row>

      <a-row class="input-form__group">
        <a-col
          :span="6"
          style="text-align: right; padding-right: 8px; padding-top: 5px"
        >
          Фамилия:
        </a-col>
        <a-col :span="12">
          <a-input v-model="form.last_name" placeholder="Введите Фамилию" />
        </a-col>
      </a-row>

      <a-row class="input-form__group">
        <a-col
          :span="6"
          style="text-align: right; padding-right: 8px; padding-top: 5px"
        >
          Логин:
        </a-col>
        <a-col :span="12">
          <a-input
            v-model="form.username"
            :spell-check="false"
            placeholder="Введите имя пользователя"
          />
        </a-col>
      </a-row>

      <a-row class="input-form__group">
        <a-col
          :span="6"
          style="text-align: right; padding-right: 8px; padding-top: 5px"
        >
          Роль:
        </a-col>
        <a-col :span="12">
          <a-select
            v-model="form.level"
            option-filter-prop="children"
            :disabled="form.id && !!form.level"
            placeholder="Выберите роль"
            style="display: block"
          >
            <a-select-option
              v-for="item in userGroups"
              :key="item.id"
              :value="item.id"
            >
              {{ item.title[$i18n.locale] }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>

      <a-row class="input-form__group">
        <a-col
          :span="6"
          style="text-align: right; padding-right: 8px; padding-top: 5px"
        >
          Пароль:
        </a-col>
        <a-col :span="12">
          <a-input-password
            v-model="form.password"
            placeholder="Введите пароль"
          />
        </a-col>
      </a-row>

      <a-row class="input-form__group sm-mb">
        <a-col :span="6" style="text-align: right; padding-right: 8px">
          Статус:
        </a-col>
        <a-switch v-model="form.status" />
      </a-row>

      <a-row type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submitForm"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </span>

    <span v-show="croping">
      <a-row class="content-title" type="flex" style="padding-top: 10px">
        <a-col :span="6" />
        <a-col :span="12">
          <h2>Обрезка изображение</h2>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="6" />
        <a-col :span="12" class="mx-auto">
          <cropper
            ref="cropper"
            classname="cropper"
            :src="cropperImage"
            :stencil-props="{
              aspectRatio: 12 / 7
            }"
            max-width="241px"
            max-height="143px"
          />
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="6" />
        <a-col :span="12" class="mx-auto">
          <a-button class="mr-10" @click="cancelCrop">Отменить</a-button>
          <a-button type="primary" @click="crop">Обрезать</a-button>
        </a-col>
      </a-row>
    </span>
  </a-row>
</template>

<script>
const defaultFormProps = () => ({
  username: "",
  password: null,
  first_name: "",
  last_name: "",
  status: true,
  level: 2
})

import { mapActions } from "vuex"

export default {
  data() {
    return {
      form: { ...defaultFormProps() },
      pending: false,
      loading: false,
      avatarInput: null,
      cropperImage: null,
      croping: false
    }
  },
  computed: {
    avatarSrc() {
      if (this.avatarInput) {
        return this.avatarInput
      }

      if (this.form.avatar) {
        return this.filesUrl + this.form.avatar
      }

      return ""
    }
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    ...mapActions("user", ["submit", "setAvatar"]),
    async fetchData() {
      if (this.$route.params.id) {
        this.loading = true
        try {
          const { data } = await this.$store.dispatch(
            "user/detail",
            this.$route.params.id
          )

          this.form = {
            ...data,
            password: ""
          }

          this.loading = false
        } catch (error) {
          console.error(error)
          this.loading = false
        }
      }
    },

    async submitForm() {
      this.pending = true

      try {
        const {
          first_name,
          last_name,
          username,
          password,
          status,
          level
        } = this.form

        const res = await this.submit({
          id: (this.form && this.form.id) || null,
          first_name,
          last_name,
          username,
          password,
          status,
          level
        })

        // console.log('res', res);

        if (res && res.id) {
          if (this.avatarInput) {
            const avatarToFile = await this.urltoFile(this.avatarInput)
            await this.setAvatar({
              userId: res.id,
              image: avatarToFile
            })

            // console.log('avatarRes', avatarRes);
          }
          this.$message.success("Успешно сохранено")
          this.$router.go(-1)
        }
        this.pending = false
      } catch (error) {
        console.error(error)
        this.pending = false
        this.$message.error(error)
      }
    },
    removeUser() {
      try {
        this.$api.delete("/admin/user/delete/" + this.form.id)
        this.$router.go(-1)
      } catch (error) {
        console.log(error)
      }
    },

    handleImage(event) {
      const input = event.target

      if (input.files && input.files[0]) {
        const reader = new FileReader()

        reader.onload = (e) => {
          this.cropperImage = e.target.result
        }

        reader.readAsDataURL(input.files[0])
        this.croping = true
      }

      this.$refs.refAvatarInput.value = null
    },

    crop() {
      const { canvas } = this.$refs.cropper.getResult()
      this.avatarInput = canvas.toDataURL()
      this.croping = false
    },

    cancelCrop() {
      this.cropperImage = this.form.avatar
      this.croping = false
    }
  }
}
</script>

<style scoped>
.cropper {
  width: 241px;
  height: 143px;
  margin-bottom: 20px;
}
</style>
